
export function copyTextToClipBoard(text:string) {
    navigator.clipboard.writeText(text)
}